import { Button } from '@one-thd/sui-atomic-components';
import React from 'react';
import PropTypes from 'prop-types';
import { productRefinementCountDataModel } from '../models/refinementCountDataModel';

export const ProductRefinementCount = ({
  onDimensionsChange,
  totalProductsCount
}) => {
  return (
    <Button fullWidth onClick={onDimensionsChange}>
      {totalProductsCount == null
        ? 'View Results'
        : `View ${totalProductsCount} Result${totalProductsCount === 1 ? '' : 's'}`}
    </Button>
  );
};

ProductRefinementCount.propTypes = {
  onDimensionsChange: PropTypes.func.isRequired,
  totalProductsCount: PropTypes.number
};

ProductRefinementCount.defaultProps = {
  totalProductsCount: 0
};

ProductRefinementCount.dataModel = productRefinementCountDataModel;
